import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "TheButton TheButtonFileLoader cursor-pointer" }
const _hoisted_2 = ["disabled", "accept"]
const _hoisted_3 = {
  key: 0,
  class: "w-full flex items-center justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", {
      type: "file",
      hidden: "",
      disabled: _ctx.disabled,
      accept: _ctx.accept,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitUpdate && _ctx.emitUpdate(...args)))
    }, null, 40, _hoisted_2),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_loader)
        ]))
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ]))
}